export const showNotification = (message, isError = false, timeout = 5000) => {
  const notification = document.createElement("div");
  notification.textContent = message;
  notification.style.cssText = `
position: fixed;
top: 20px;
right: 20px;
padding: 15px;
border-radius: 4px;
color: white;
background: ${isError ? "#ff4444" : "#44b544"};
z-index: 1000;
animation: fadeIn 0.3s ease-in;
`;
  document.body.appendChild(notification);
  setTimeout(() => {
    notification.style.animation = "fadeOut 0.3s ease-out";
    setTimeout(() => notification.remove(), 300);
  }, timeout);
};
